import { render, staticRenderFns } from "./ObservacoesDiscordar.vue?vue&type=template&id=286ebf89&scoped=true"
import script from "./ObservacoesDiscordar.vue?vue&type=script&lang=js"
export * from "./ObservacoesDiscordar.vue?vue&type=script&lang=js"
import style0 from "./ObservacoesDiscordar.vue?vue&type=style&index=0&id=286ebf89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286ebf89",
  null
  
)

export default component.exports